var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"dir":"ltr"}},[_c('apexchart',{staticClass:"apex-charts",attrs:{"type":"area","options":_vm.chartOptions,"height":"260","series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }